module.exports = __webpack_public_path__ + "03_mole.5c741f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/03_mole.png
// module id = uuzH
// module chunks = 0